module.exports = __webpack_public_path__ + "static/media/chess-knight.938ea569.svg";